import { useNavigate } from "react-router-dom";
import { useState } from "react";
import type { StaffServiceItem } from "@/api/guide";
import type { StaffDetail } from "@/api/guide";
import { THEME } from "../constants";

interface ServiceItemsProps {
  guide: StaffDetail;
  items: StaffServiceItem[];
}

export default function ServiceItems({ guide, items }: ServiceItemsProps) {
  const navigate = useNavigate();
  const [activeServiceTab, setActiveServiceTab] = useState(0);

  if (items.length === 0) return null;

  return (
    <div className="mx-4 mt-4 rounded-2xl" style={{ background: "rgba(255,255,255,0.05)" }}>
      {/* 分类 Tab 栏 */}
      <div className="flex border-b px-4 pt-3" style={{ borderColor: "rgba(255,255,255,0.08)" }}>
        {["所有项目",].map((tab, i) => (
          <button
            key={tab}
            onClick={() => setActiveServiceTab(i)}
            className="px-1 pb-3 mr-5 text-sm font-medium cursor-pointer whitespace-nowrap transition-colors relative"
            style={{ color: activeServiceTab === i ? "#FFF" : "rgba(255,255,255,0.45)" }}
          >
            {tab}
            {activeServiceTab === i && (
              <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-5 h-[3px] rounded-full" style={{ background: THEME.primary }} />
            )}
          </button>
        ))}
      </div>

      {/* 项目列表 */}
      <div className="px-4 py-3 space-y-3">
        {items.map((p) => (
          <div key={p.id} className="flex items-center gap-3">
            <img src={p.thumb || guide.avatar} alt="" className="w-14 h-14 rounded-lg object-cover flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-white truncate">{p.title}</div>
              {(p.accept_order_type === 0 || p.accept_order_type === 1) && p.price && Number(p.price) > 0 && (
                <div className="text-xs mt-1" style={{ color: THEME.primary }}>¥{Number(p.price).toFixed(2)}/{p.unit_name}</div>
              )}
              {(p.accept_order_type === 0 || p.accept_order_type === 2) && p.day_order_money && Number(p.day_order_money) > 0 && (
                <div className="text-xs" style={{ color: THEME.primary }}>¥{Number(p.day_order_money).toFixed(2)}/{p.day_unit_name}</div>
              )}
              {!((p.accept_order_type === 0 || p.accept_order_type === 1) && Number(p.price) > 0) &&
               !((p.accept_order_type === 0 || p.accept_order_type === 2) && Number(p.day_order_money) > 0) && (
                <div className="text-xs mt-1" style={{ color: "rgba(255,255,255,0.35)" }}>暂无报价</div>
              )}
            </div>
            <button
              className="px-4 py-1.5 rounded-full text-xs font-semibold text-white flex-shrink-0 cursor-pointer active:scale-95 transition-transform"
              style={{ background: THEME.primary }}
              onClick={() => navigate("/expert-confirm", { state: { staffId: guide.id, itemId: p.id } })}
            >
              去下单
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
